import type { CSSProperties } from 'react';

import { isDefined } from '@enterprise/core';

import type { LoadingProps } from './types/loading.props';

/**
 * Renders a grid-style loading indicator.
 *
 * @internal
 * @param size - The size multiplier for the loader grid. If greater than 1, applies a corresponding CSS class.
 * @returns A JSX element representing the loading grid.
 */
export const Grid = ({ size }: LoadingProps) => {
  return (
    <div
      className="loader-grid"
      style={{ '--multiplier': isDefined(size) ? size : undefined } as CSSProperties}>
      {Array.from({ length: 9 }, (_, i) => {
        return (
          // biome-ignore lint/suspicious/noArrayIndexKey: This is a static array for loader elements
          <div key={i} />
        );
      })}
    </div>
  );
};
